import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import RatingStars from 'components/Common/RatingStars'
import InlineGroup from 'components/Common/InlineGroup/index'
import facebookLogo from './facebook-logo.svg'
import Caption from 'components/Luxkit/Typography/Caption'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: ${rem(8)};
`

const StyledImg = styled.img`
  max-width:100%;
  display: block;
`

interface Props {
  prefix?: string;
  horizontal?: boolean;
}

function SocialStars(props: Props) {
  return <Wrapper>
    <InlineGroup
      equal={!props.horizontal}
      size="sm"
      vertical={props.horizontal ? 'center' : 'baseline'}
      horizontal={props.horizontal ? 'center' : undefined}
    >
      <div style={{ width: '80px' }}>
        <StyledImg src={facebookLogo} alt="Facebook"/>
      </div>
      <div>
        <RatingStars color="#4667AA" maskWidth={111} maskId={props.prefix ? `facebook-${props.prefix}` : 'facebook'} width={69} height={13}/>
      </div>
      { props.horizontal && <Caption variant="medium" align="justify" as="span">1,436,819 followers</Caption>}
    </InlineGroup>
    {!props.horizontal && <Caption variant="medium" align="center"><strong>1,411,912 people </strong>like us</Caption>}
  </Wrapper>
}

export default SocialStars
